export * from "@auth/core/providers/microsoft-entra-id";
export { default } from "@auth/core/providers/microsoft-entra-id";
